import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";

const ROWS = [
  ["24 anos de experiência", "Menos erros e crescimento mais rápido"],
  ["Diretor operacional dedicado", "Apoio próximo nos momentos críticos"],
  ["CRM próprio", "Organização e produtividade"],
  ["Inteligência Artificial", "Diferenciação e eficiência"],
  ["Rede nacional", "Partilha de conhecimento"],
  ["Cultura humana", "Crescimento sustentável"],
];

export const Differentiators = () => (
  <section id="diferenciais" className="bg-white py-24 text-ink sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Eyebrow num="06">O que nos diferencia</Eyebrow>
      <h2 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
        <MaskLines lines={["Porque escolher a", <span className="text-orange-deep">Soluções Ideais?</span>]} />
      </h2>
      <div className="mt-16" data-testid="differentiation-table">
        <div className="grid grid-cols-2 border-b-2 border-ink pb-4 font-mono text-xs uppercase tracking-[0.22em] text-slate-500">
          <span>O que encontra</span><span>Benefício</span>
        </div>
        {ROWS.map(([a, b], i) => (
          <Reveal key={a} delay={i * 0.05}>
            <div data-testid={`diff-row-${i}`} className="diff-row group relative grid grid-cols-2 items-center gap-4 overflow-hidden border-b border-ink/15 py-6 sm:py-8">
              <span className="relative z-10 flex items-center gap-4 font-display text-lg font-extrabold transition-colors duration-500 group-hover:text-white sm:text-3xl">
                <span className="hidden font-mono text-xs font-medium text-slate-500 transition-colors duration-500 group-hover:text-white/80 sm:inline">0{i + 1}</span>{a}
              </span>
              <span className="relative z-10 flex items-center justify-between gap-3 text-sm text-slate-600 transition-colors duration-500 group-hover:text-white sm:text-lg">
                {b}
                <ArrowUpRight className="hidden h-6 w-6 shrink-0 -translate-x-3 opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-x-0 group-hover:opacity-100 sm:block" />
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
